export let registerForm = [
    {
        key: "name", label: "Name", displayName: "Name", order: 1, type: "string",
        error: "", value: "", helperText: "", required: true, titleCase: true,
        regExp: /[A-Za-z0-9\s.]{2,35}$/,
        regExMessage: "Invalid name"
    },
    {
        key: "email", label: "Email", displayName: "Email", order: 2, type: "string",
        error: "", value: "", helperText: "", required: true, titleCase: true,
        regExp: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/,
        regExMessage: "Invalid email id"
    },
    {
        key: "password", label: "Password", displayName: "Password", order: 3, type: "password",
        error: "", value: "", helperText: "", required: true, titleCase: true,
        regExp: /^[A-Za-z0-9_@%$./#&!+-]{5,25}$/,
        regExMessage: "Invalid password"
    },
    {
        key: "confirmPassword", label: "Confirm Password", displayName: "Confirm Password", order: 4,
        type: "password", error: "", value: "", helperText: "", required: true, titleCase: true,
        regExp: /^[A-Za-z0-9_@%$./#&!+-]{5,25}$/,
        regExMessage: "Invalid password"
    },
    {
        key: "role", label: "Role", displayName: "Role", order: 5,
        type: "select", error: "", value: "user", helperText: "", required: true, select: true,
        options:[{"key":"user","value":"user"},{"key":"manager","value":"manager"}]
    },

];


